import React, { useState, useEffect, useContext, useRef } from 'react';
import { Calendar, dayjsLocalizer  } from 'react-big-calendar'
import moment from 'moment'
import axios from "axios";
//import Grid from '@mui/material/Grid';
//import CircularProgress from '@mui/material/CircularProgress';

//When copying datetimes, cloneDeep.
import cloneDeep from 'lodash/cloneDeep';

//Contexts
import { AppContext, AppProvider } from "../Auth/contexts/AppContext"
//Error Context
//*Can be used for success as well!
//Types: ok, warning, danger, neutral
import ErrorMessage from "../common/ErrorMessage";
import { ErrorContext } from '../common/ErrorContext';

import { v4 as uuidv4 } from 'uuid';

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';
import { useMediaQuery } from "@mui/material";

import Checkbox from '@mui/material/Checkbox';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/GridLegacy';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

//Datetime Pickers
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import TextareaAutosize from '@mui/material/TextareaAutosize';
//Datetime formatting
import Moment from 'react-moment';

import dayjs from 'dayjs'; //Used with new datetimepickers
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //New adapter for mui x 7 datetime

//Icons
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import PendingIcon from '@mui/icons-material/Pending'; 

//Buttons
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';


import '../../css/react-big-calendar.css';

//let endpoint = "http://localhost:8080/api";
var hostbase = process.env.REACT_APP_ANGULAR_LEGACY_BASE;
var dbendpoint = process.env.REACT_APP_DB_API4;


//MainPage receives props? Let's try without.
const FlexCalendar = () => {
	/* App Context */
	/* Allows userperms to be used */
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;
	//Error Context
	const errors = useContext(ErrorContext);

	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	const btnSave = useRef();
	const btnSave2 = useRef();

	//const btnSave = useRef();
	const btnPendingSave = useRef();

	//Error Context
	//const errors = useContext(ErrorContext);

	const testevents = {
		events: [
			// {
			// 	start: moment().toDate(),
			// 	end: moment()
			// 		.add(1, "days")
			// 		.toDate(),
			// 	title: "Some title"
			// }
		]
	};

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};


	//Lets switch search to look for current month.....
	const initialdate = new Date();


	/* ##########################  UseState Variables  ########################## */
	const [state, setState] = useState({
		calendarid: uuidv4(),
		dbreload: true, 		//Use in useEffect to check if we should reload the griditems data. Set to false when we're just updating current view items.
		events: testevents.events,
		currentevent: null,
		clearselection: true,//Default clear selection everytime we reload DB. Continuous bulk edits may set this to false between updates.
		griditems: [],		//Empty object
		defaultvalues: [],   //Default values: Useful for initial render.
		totalitems: 0,
		page: 0, //Assume page 0, or else pagination throws an error.
		order: "asc",
		orderby: "start",
		selectedcount: 0,
		rowsperpage: 10,
		selectedindexes: [],
		pendingsaves: false, //Used for parent view - Warnings about unsaved items!
		searchoptions: {
			currentsearchdate:initialdate,
			//New! Key-Value pair array. Easier to itterate in API.
			searchpairs: {
				//Reserved for basic searchpairs. Possible injection of search parameter 'nameparameter' here.
				//Modes: like, left, right, strict, not
				searchpair1: { type: "", value: "", mode: "datetimeafter" },
				searchpair2: { type: "", value: "", mode: "datetimebefore" },
				searchpair3: { type: "", value: "", mode: "left" },
				searchpair4: { type: "", value: "", mode: "right" },
				searchpair5: { type: "", value: "", mode: "like" },
				searchpair6: { type: "", value: "", mode: "like" },
				//Reserved for AutoComplete searchpairs.
				searchpair7: { type: "", value: "", mode: "strict" },
				searchpair8: { type: "", value: "", mode: "strict" },
				searchpair9: { type: "", value: "", mode: "strict" },
				searchpair10: { type: "", value: "", mode: "strict" },
			},
			nestedrelationships: {

			},
			itemlist: ""
		}
	});

	//Clone State! We'll get the view from localstate!
	let localstate = Object.assign({}, state);

	function UpdateState(stateobject) {
		setState(stateobject);
	}

	//Default Axios Post Options
	const defaultpostoptions = {
		withCredentials: true,
		withXSRFToken: true,
		crossDomain: true,
		mode: "no-cors",
		timeout: 11800,
	};

	const LoadCalendarEvents = () => {
		const postdata = {
			searchoptions: {
				limit: localstate.rowsperpage,
				currentsort: localstate.orderby,
				currentsortdir: localstate.order,
				currentsearchdate: localstate.searchoptions.currentsearchdate,
				searchpairs: localstate.searchoptions.searchpairs,
				nestedrelationships: localstate.searchoptions.nestedrelationships
			}
		};
		axios.post(dbendpoint + "/calendar/getevents", postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					//console.log(res);
					localstate.events = res.data.events;


					for (var i=0; i<localstate.events.length; i++){
						// localstate.events[i].start = dayjs(localstate.events[i].start);
						// localstate.events[i].end = dayjs(localstate.events[i].end);


						//Create a version of the date that can be used to render the react-big-calendar (Date object)

						//Big Calendar handles JS Dates better than dayjs somehow.
						//A little learning about this topic:
						//When copying something from a resultant, the result is parsed as an....
						//console.log("TypeOf:"+typeof localstate.events[i]); //Is object.
						//Lookup copying primitives vs references. 
						//Copying primitives: strings, numbers, integers, booleans, null, undefined, symbol, bigint - Creates a copy of the value. You can reassign primitives individually.

						//Copying References: objects, arrays, functions - Creates a references to the location in memory, so when one changes, so does the other.

						//It needs to be a copy of the data, not just a reference to the date that we will then morph into dayjs values.
						localstate.events[i].startdate = new Date(cloneDeep(localstate.events[i].start));
						localstate.events[i].enddate = new Date(cloneDeep(localstate.events[i].end));


						//Create a copy of the dates so we can use them when we go to view one.
						localstate.events[i].start = dayjs(localstate.events[i].start);
						localstate.events[i].end = dayjs(localstate.events[i].end);


						

						


						//console.log(localstate.events[i].end);
					}



					//Do we need to pre-format all the events to have Date types?
					//We should already have something useful from the API - Carbon formatting already performed.
					//Try to remove this:
					// for (var i=0; i<localstate.events.length; i++){
					// 	localstate.events[i].start = new Date(Date.parse(localstate.events[i].start));
					// 	localstate.events[i].end = new Date(Date.parse(localstate.events[i].end));
					// }
					UpdateState(localstate);

				}
				if (res.data.Status === "Failure") {
					//Failure error
					//errors.NewError({errmsg:res.data.message, errshow:true, errtimeout: 5, errtype:"neutral"})
				}
			} else {
				//Non-200 message from server.
				//errors.NewError({errmsg:"Bad response from server.", errshow:true, errtimeout: 5, errtype:"warning"})
			}
		});
	}

	const SaveChanges = () => {
		if (!localstate.currentevent.title) {
			errors.NewError({ errmsg: "Error: Event title is empty.", errshow: true, errtimeout: 15, errtype: "danger" });
			return;
		}
		if (!localstate.currentevent.start) {
			errors.NewError({ errmsg: "Error: Start date is empty.", errshow: true, errtimeout: 15, errtype: "danger" });
			return;
		}
		if (!localstate.currentevent.end) {
			errors.NewError({ errmsg: "Error: End date is empty.", errshow: true, errtimeout: 15, errtype: "danger" });
			return;
		}
		if (localstate.currentevent.start > localstate.currentevent.end) {
			errors.NewError({ errmsg: "Error: Start date is after end date.", errshow: true, errtimeout: 15, errtype: "danger" });
			return;
		}

		let postdata = {
			item: localstate.currentevent
		};

		axios.post(dbendpoint + "/calendar/update", postdata, defaultpostoptions).then(res => {
			if (res.status === 200) {
				if (res.data.Status === "login") {
					window.location.reload(false);
				}

				if (res.data.Status === "Success") {
					btnSave.current.style.display = "";
					btnPendingSave.current.style.display = "none";

					localstate.pendingsaves = false;
					localstate.currentevent = null;

					// simplest and safest: reload from server
					localstate.dbreload = true;
					UpdateState({ ...localstate });

					// optional direct fetch:
					LoadCalendarEvents();
				}

				if (res.data.Status === "Failure") {
					errors.NewError({ errmsg: res.data.message, errshow: true, errtimeout: 15, errtype: "warning" });
				}
			} else {
				errors.NewError({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" });
			}
		});
	};

	//Possible erroneous...
	//window.addEventListener("resize", debounce(handleWindowSize, 5000));

	const handleWindowSize = () => {
		const chartwidthelement = document.getElementById(state.calendarid);
		console.log(chartwidthelement);
		if (chartwidthelement){
			var w = chartwidthelement.offsetWidth;
			//return;
		}		
	}

	const NavigateDate = (event) => {
		//console.log(event);
		localstate.searchoptions.currentsearchdate = event;
		LoadCalendarEvents();
	}

	const DeleteEvent = () => {
		//New Events don't even exist until Save is hit. If we're dealing with a pending event, we can just close the view.
		if (localstate.currentevent.PendingItem){
			CloseEvent();
		} else {
			let postdata = {
				item: localstate.currentevent
			}
			axios.post(dbendpoint + "/calendar/delete", postdata, defaultpostoptions).then(res => {
				if (res.status === 200){
						if (res.data.Status === "login"){
						window.location.reload(false);
					}
					if (res.data.Status === "Success") {
						localstate.currentevent = null;
						var itemindex = localstate.events.map(function(o) { return o.id; }).indexOf(res.data.OldID);
						localstate.events.splice(itemindex, 1);
						UpdateState(localstate);
					}
					if (res.data.Status === "Failure") {
						//Failure error
						errors.NewError({ errmsg: res.data.message, errshow: true, errtimeout: 15, errtype: "warning" })
					}
				} else {
					//Non-200 message from server.
					errors.NewError({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" })
				}
				
			})
		}
		
	}

	const CloseEvent = () => {
		localstate.currentevent = null;
		localstate.dbreload = true;
		UpdateState(localstate);
	}

	const AddEvent = () => {
		localstate.currentevent = {
			PendingItem:true,
			id:uuidv4(),
			title:"New Event",
			details:"",
			start:"",
			end:""
		};
		UpdateState(localstate);
	}

	useEffect(() => {
		if (state.dbreload) {
			//Avoid duplicate loads.
			state.dbreload = false;
			LoadCalendarEvents();
		}
	}, [state.dbreload]);

	const ViewEvent = (event) => {
		console.log(event);
		localstate.currentevent = event;
		UpdateState(localstate);
	}

	//Changes to item
	const onChangeValue = (event, itemkey) => {
		var oldvalue = localstate.currentevent[itemkey];
		var newvalue = event.target.value;
		if (event.key !== "Tab" &&
			event.key !== "ArrowDown" &&
			event.key !== "ArrowUp" &&
			event.key !== "ShiftLeft" &&
			event.key !== "ShiftRight"
		) {

			if (itemkey === "SomeBoolean") {
				if (event.target.checked) {
					localstate.currentevent.SomeBoolean = 1;
				} else {
					localstate.currentevent.SomeBoolean = 0;
				}
			}


			//All others
			if (itemkey === "title" || itemkey === "details") {
				localstate.currentevent[itemkey] = newvalue;
			}
			localstate.pendingsaves = true;
			btnSave.current.style.display="none";
			btnPendingSave.current.style.display="";
			UpdateState(localstate);
		}

	}

	const onChangeDatetimeValue = (newvalue, itemkey) => {
		localstate.currentevent[itemkey] = newvalue;
		if (itemkey==='start'){
			localstate.currentevent.startmodified = true;
		}
		if (itemkey==='end'){
			localstate.currentevent.endmodified = true;
		}
		localstate.pendingsaves = true;
		btnSave.current.style.display="none";
		btnPendingSave.current.style.display="";
		UpdateState(localstate);

	}


	const localizer = dayjsLocalizer(dayjs);
	//Hide Scroll Bars for injected content.
	return (
		<>

			<div style={{ margin: "auto", padding: "60px 20px 20px 20px", textAlign: "center" }}>
				<div style={{height:"800px", minWidth:"400px"}}>
					{/* react-big-calendar*/}
					
					<Calendar
					showAllEvents={true}
					id={state.calendarid}
					localizer={localizer}
					events={state.events}
					startAccessor="startdate"
					endAccessor="enddate"
					onNavigate={(event)=>{NavigateDate(event)}}
					onSelectEvent={(event) => ViewEvent(event)}
					
				/>
				</div>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					{/* It may be possible that our localizer is messing with our Calendar */}
					<div style={{ width: "100%", border: "1px solid #DDD", padding: "10px" }}>
					{(!localstate.currentevent) &&
						<Box sx={{ textAlign:"right", marginBottom:"10px" }}>
						<Button className={classes.bluebtn}
														color="primary" variant="contained"
						sx={{width:"180px"}}
							size="medium"
							onClick={() => AddEvent()}
							>
							<AddIcon />Add New Event
						</Button>
						</Box>
					
					}


					{(localstate.currentevent) &&

						<div>
							
							<div className={classes.itemtableheader} style={{marginTop:"0px", height:"30px", paddingRight:"10px"}}>Event Details
								<div style={{ float:"right", height: "24px", textAlign: "center", fontSize: "12px" }}>
									{(errors.currenterror.errshow) &&
										<ErrorMessage />
									}
								</div>
							</div>
								<Typography variant="h6">
									<Grid container spacing={0}  direction={{ sm: 'column-reverse', md: 'row' }}>



										<Grid item xs={12} sm={12} md={6} lg={4}>
											<table className={classes.itemtable}>
												<tbody>
													<tr>
														<td style={{ width: "65px" }}>
															Title:
														</td>
														<td>
															{(userPerms.updateCalendarEvent === 1) &&
																<input className={classes.flexiteminput}
																	type="text"
																	value={localstate.currentevent.title}
																	onChange={(event) => onChangeValue(event, "title")}
																/>
															}
															{(userPerms.updateCalendarEvent === 0) &&
																<div className={classes.flexitemstaticinput}>
																	{localstate.currentevent.title}
																</div>
															}
														</td>
													</tr>
													<tr>
														<td>
															Start:
														</td>
														<td>
															{(userPerms.updateCalendarEvent === 1) &&
																<div className={classes.flexmuixdatetime}>
																	<DateTimePicker
																		value={dayjs(localstate.currentevent.start)}
																		onChange={(newvalue) => onChangeDatetimeValue(newvalue, "start")}
																		slotProps={{
																			textField: {
																				variant: "standard",
																				fullWidth: true,
																			}
																		}}
																	/>
																</div>
															}
															{(userPerms.updateCalendarEvent === 0) &&
																<div className={classes.flexitemstaticinput}>
																	{/* <Moment element='span' format="MMMM D, YYYY [at] h:mma">{localstate.currentevent.start}</Moment> */}
																</div>
															}
														</td>
													</tr>
													<tr>
														<td>
															End:
														</td>
														<td>
															{(userPerms.updateCalendarEvent === 1) &&
																<div className={classes.flexmuixdatetime}>
																	<DateTimePicker
																		value={dayjs(localstate.currentevent.end)}
																		onChange={(newvalue) => onChangeDatetimeValue(newvalue, "end")}
																		slotProps={{
																			textField: {
																				variant: "standard",
																				fullWidth: true,
																			}
																		}}
																	/>
																</div>
															}
															{(userPerms.updateCalendarEvent === 0) &&
																<div className={classes.flexitemstaticinput}>
																	{/* <Moment element='span' format="MMMM D, YYYY [at] h:mma">{localstate.currentevent.end}</Moment> */}
																</div>
															}
														</td>
													</tr>
												</tbody>
											</table>
										</Grid>


										{/* Right side buttons stack on top if screen is too small */}
										<Grid item xs={12} sm={12} md={6} lg={8}>
										
											<Box sx={{ textAlign: {
          sm: 'center', // Center text on extra small screens
          md: 'right',   // Align left on small screens and larger
        }, marginBottom: "5px", marginTop: "10px" }}>
												<Button className={classes.bluebtn}
													color="primary" variant="contained"
													sx={{ width: "180px" }}
													onClick={() => CloseEvent(false)}
												>
													Close Event
												</Button>
											</Box>


											{(userPerms.updateCalendarEvent === 1) &&
												<Box sx={{
													textAlign: {
													  sm: 'center', // Center text on extra small screens
													  md: 'right',   // Align left on small screens and larger
													}, marginBottom: "5px", marginTop: "5px" }}>
													<Button
														className={classes.bluebtn}
														color="primary" variant="contained"
														sx={{ width: "180px" }}
														onClick={() => SaveChanges()}
														ref={el => btnSave.current = el}>
														<SaveIcon sx={{ color: "lightgray" }}></SaveIcon>&nbsp;Save Changes
													</Button>
													<Button
														className={classes.bluebtn}
														color="primary" variant="contained"
														sx={{ width: "180px" }}
														style={{ display: "none" }}
														onClick={() => SaveChanges()}
														ref={el => btnPendingSave.current = el}>
														<PendingIcon sx={{ color: "orange" }}></PendingIcon>&nbsp;Save Changes
													</Button>
												</Box>
											}


											{(userPerms.deleteCalendarEvent === 1) &&
												<Box sx={{
													textAlign: {
													  sm: 'center', // Center text on extra small screens
													  md: 'right',   // Align left on small screens and larger
													}, }}>
													<Button className={classes.bluebtn}
														color="primary" variant="contained"
														sx={{ width: "180px" }}
														size="medium"
														onClick={() => DeleteEvent()}
													>
														<DeleteIcon />&nbsp;&nbsp;Delete Event
													</Button>
												</Box>
											}

										</Grid>





										
											
											
									





										
									</Grid>


									<Grid item sm={12} md={12}>
											<table className={classes.itemtable}>
												<tbody>
													<tr>
														<td style={{ width: "65px" }}>
															Details:
														</td>
														<td>
														{(userPerms.updateCalendarEvent === 1) &&
														<TextareaAutosize
															style={{ minHeight: "50px", backgroundColor: "#EEE" }}
															className={classes.flexiteminput}
															value={(localstate.currentevent.details ? localstate.currentevent.details : "")}
															onChange={(event) => onChangeValue(event, "details")}
														/>
														}
													
														{(userPerms.updateCalendarEvent === 0) &&
															<TextareaAutosize
															style={{ minHeight: "50px", backgroundColor: "#EEE" }}
															className={classes.flexiteminput}
															value={(localstate.currentevent.details ? localstate.currentevent.details : "")}
															disabled
															/>
														}
														</td>
													</tr>
													
												</tbody>
											</table>
										</Grid>
								</Typography>
							{(!localstate.currentevent.PendingItem) &&
								<div style={{textAlign:"left", paddingLeft:"65px"}}>
									Created By: {localstate.currentevent.CreatedBy} on <Moment element='span' format="MMMM D, YYYY [at] h:mma">{localstate.currentevent.created_at}</Moment><br></br>
								</div>
							}							
							
						</div>
					}

				</div>
				</LocalizationProvider>
				
			</div>

		</>

	)
}


export default FlexCalendar;